import classNames from 'classnames'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyles = createUseStyles(style)

const CategoryDescription = ({
  pretitle,
  title,
  info,
  reverse,
}) => {
  const classes = useStyles()

  return (
    <div
      className={classNames({
        [classes.root]: true,
        [classes.rootReverse]: reverse,
      })}
    >
      <div className={classes.desc}>
        <div className={classes.info}>
          {pretitle && <div className={classes.pretitle}>{pretitle}</div>}
          {info && <h2 dangerouslySetInnerHTML={{ __html: info }} />}
        </div>
      </div>
      <div>
        {title && (
          <h1
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
      </div>
    </div>
  )
}

export default CategoryDescription
